(function ($) {

    $('body').on('click', '.nav-chat-trigger, .nav-chat .close-button span', toggleClass);   

    function toggleClass(e) {
        e.preventDefault();
         var isOpen = $(this).closest('.nav-chat').hasClass('nav-chat-on');
        $('.nav-chat').removeClass('nav-chat-on');
        $('.nav-ecommerce').removeClass('nav-ecommerce-on');
        if(!isOpen) {
             $(this).closest('.nav-chat').toggleClass('nav-chat-on');
        }
    }

}(window.jQuery));


// Analytics
analytics.eventConfig.push({
    "target": ".nav-chat",
    "codeId": "wo",
    "events": [
        {
            "eventTarget": "a.nav-chat-trigger",
            "eventType": "click",
            "tags": {
                "componentName": "wechat option",
                "componentId": "wo",
                "event": "navigation",
                "eventType": "wechat option open click",
                "elementType": "wechat option",
                "parentName": ""

            }
        },
        {
            "eventTarget": ".close-button",
            "eventType": "click",
            "tags": {

                "componentName": "wechat option",
                "componentId": "wo",
                "event": "navigation",
                "eventType": "wechat option x out click",
                "elementType": "wechat option x out",
                "parentName": ""
            }
        }
    ]
});
(function ($) {
    $(document).ready(function () {
        var qrExists = $(".chat-wrapper");
        if (qrExists.length) {
            $(qrExists).each(function () {
                var find = $(this).find(".qr-column").length;
                if (find == 1) {
                    $(this).addClass("only-child");
                }
            });
        }
    });
}(window.jQuery));